"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const luxon_1 = require("luxon");
const BaseModel_1 = tslib_1.__importDefault(require("./BaseModel"));
const createTimeEntry_graphql_1 = tslib_1.__importDefault(require("../gql/tasks/mutations/createTimeEntry.graphql"));
const updateTimeEntry_graphql_1 = tslib_1.__importDefault(require("../gql/tasks/mutations/updateTimeEntry.graphql"));
const stopTimeEntry_graphql_1 = tslib_1.__importDefault(require("../gql/tasks/mutations/stopTimeEntry.graphql"));
const deleteTimeEntry_graphql_1 = tslib_1.__importDefault(require("../gql/tasks/mutations/deleteTimeEntry.graphql"));
class TimeEntry extends BaseModel_1.default {
    constructor() {
        super(...arguments);
        this.createMutation = createTimeEntry_graphql_1.default;
        this.updateMutation = updateTimeEntry_graphql_1.default;
    }
    defaults() {
        return {
            uuid: null,
            title: null,
            taskUuid: null,
            userUuid: null,
            projectUuid: null,
            startTime: null,
            endTime: null,
            active: false,
            isBillable: false,
        };
    }
    get total() {
        const startTime = luxon_1.DateTime.fromISO(this.startTime);
        const endTime = luxon_1.DateTime.fromISO(this.endTime);
        return luxon_1.Duration.fromMillis(endTime - startTime).toFormat('h:mm:ss');
    }
    getDuration() {
        const startTime = luxon_1.DateTime.fromISO(this.startTime);
        const endTime = luxon_1.DateTime.fromISO(this.endTime);
        if (this.active) {
            const now = luxon_1.DateTime.local().toMillis();
            return luxon_1.Duration.fromMillis(now - startTime).toFormat('h:mm:ss');
        }
        return luxon_1.Duration.fromMillis(endTime - startTime).toFormat('h:mm:ss');
    }
    stop() {
        const _super = Object.create(null, {
            mutate: { get: () => super.mutate }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { uuid } = this;
            return _super.mutate.call(this, stopTimeEntry_graphql_1.default, { uuid });
        });
    }
    delete() {
        const _super = Object.create(null, {
            delete: { get: () => super.delete }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return _super.delete.call(this, deleteTimeEntry_graphql_1.default);
        });
    }
}
exports.default = TimeEntry;
//# sourceMappingURL=TimeEntry.js.map